// Этап 24 — фабрика случайных Модов Синтетика.
//
// API:
//   generateRandomMod(state, ownerIdx, { destination, target, excludeIds }) → { ok, mod? }
//     destination:
//       'hand'    — Mod-карта появляется в руке owner'а (с лимитом 10).
//       'discard' — Mod-карта в сброс owner'а.
//       'attach'  — Мод сразу вешается на target (вызов attachMod, isPlayed=false).
//     target — Card-юнит на поле (для 'attach'). Игнорируется иначе.
//     excludeIds — Set<string> id, исключённые из пула (например, если нужно
//                  не дублировать уже носимый Мод).
//
// Источник Модов — все Mod-шаблоны из cards-syntetics.js (16 шт, deck_limit=1).

import { Card } from '../../../card.js';
import { cards as cardsSyntetics } from '../../../../data/cards-syntetics.js';
import { attachMod } from '../modifications.js';

const ALL_MOD_TEMPLATES = cardsSyntetics.filter(c => c.type === 'mod');

function pickRandomMod(state, excludeIds = new Set()) {
  const pool = ALL_MOD_TEMPLATES.filter(t => !excludeIds.has(t.id));
  if (pool.length === 0) return null;
  const idx = state?.rng?.int ? state.rng.int(pool.length) : Math.floor(Math.random() * pool.length);
  return pool[idx];
}

export function generateRandomMod(state, ownerIdx, opts = {}) {
  const { destination = 'hand', target = null, excludeIds = new Set() } = opts;
  const owner = state?.players?.[ownerIdx];
  if (!owner) return { ok: false, reason: 'no_owner' };

  const tpl = pickRandomMod(state, excludeIds);
  if (!tpl) return { ok: false, reason: 'no_mod_available' };

  if (destination === 'attach') {
    if (!target) return { ok: false, reason: 'no_target' };
    const r = attachMod(state, target, { id: tpl.id, name_ru: tpl.name_ru }, { isPlayed: false });
    state?.log?.add?.(`🔧 Случайный Мод "${tpl.name_ru}" → ${target.name_ru}`);
    return { ok: r.ok, mod: tpl, attached: r.ok };
  }

  // hand / discard — создаём Card-инстанс.
  const card = new Card(tpl);
  card.ownerId = ownerIdx;

  if (destination === 'hand') {
    if (owner.hand.length >= 10) {
      // Лимит руки — Мод сгорает.
      state?.log?.add?.(`🛒 Случайный Мод "${tpl.name_ru}" сгорел (рука полная)`);
      return { ok: false, reason: 'hand_full', mod: tpl };
    }
    owner.hand.push(card);
    state?.log?.add?.(`🛒 Случайный Мод "${tpl.name_ru}" → в руку [${owner.name}]`);
    return { ok: true, mod: tpl, card };
  }
  if (destination === 'discard') {
    owner.discard.push(card);
    state?.log?.add?.(`🛒 Случайный Мод "${tpl.name_ru}" → в сброс [${owner.name}]`);
    return { ok: true, mod: tpl, card };
  }
  return { ok: false, reason: 'bad_destination' };
}

// Список ID для удобства (для тестов).
export function getAllModIds() {
  return ALL_MOD_TEMPLATES.map(t => t.id);
}
